module.exports = __webpack_public_path__ + "static/media/entrp.5052b0b3.svg";